import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import Vuelidate from "vuelidate";
import Notifications from "vue-notification";

import VueHtmlToPaper from "vue-html-to-paper";
Vue.use(Vuelidate);
Vue.use(Notifications);
Vue.use(VueHtmlToPaper);

Vue.config.productionTip = false;

let VUE = new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");

export default VUE;
